module.exports = __webpack_public_path__ + "assets/img/Futurama_author.0da2c6ca-ps.jpg";